<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: 'bpp',

          // SINGLE
          single: false,

          // CHECKBOX
          checkbox: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'No. Reg',
              width: '200px',
              value: 'bpp_no_reg',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Lengkap',
              width: '300px',
              value: 'bpp_nama',
              freeze: false,
              hide: false
            },
            {
              text: 'NIK',
              width: '200px',
              value: 'bpp_nik',
              freeze: false,
              hide: false
            },
            {
              text: 'Tempat Lahir',
              width: '200px',
              value: 'bpp_tempat_lahir',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal Lahir',
              width: '200px',
              value: 'bpp_tanggal_lahir',
              freeze: false,
              hide: false,
              format: 'date'
            },
            {
              text: 'Tempat Meninggal',
              width: '300px',
              value: 'bpp_tempat_meninggal',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal Meninggal',
              width: '200px',
              value: 'bpp_tanggal_meninggal',
              freeze: false,
              hide: false,
              format: 'date'
            },
            {
              text: 'Alamat',
              width: '400px',
              value: 'bpp_alamat',
              freeze: false,
              hide: false
            },
            {
              text: 'RT',
              width: '100px',
              value: 'bpp_rt',
              freeze: false,
              hide: false,
              align: 'center'
            },
            {
              text: 'RW',
              width: '100px',
              value: 'bpp_rw',
              freeze: false,
              hide: false,
              align: 'center'
            },
            {
              text: 'Desa / Kelurahan',
              width: '300px',
              value: 'bpp_desa_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Kecamatan',
              width: '300px',
              value: 'bpp_kecamatan_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Keterangan',
              width: '400px',
              value: 'bpp_note',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal Pemakaman',
              width: '200px',
              value: 'bpp_tanggal_pemakaman',
              freeze: false,
              hide: false,
              format: 'date'
            },
            {
              text: 'Dimakamkan Di',
              width: '300px',
              value: 'bpp_makam_nama',
              freeze: false,
              hide: false
            },
            {
              text: 'Desa Pemakaman',
              width: '300px',
              value: 'bpp_makam_desa_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Kecamatan Pemakaman',
              width: '300px',
              value: 'bpp_makam_kecamatan_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Keluarga',
              width: '200px',
              value: 'bpp_keluarga_telp_nama',
              freeze: false,
              hide: false
            },
            {
              text: 'Telepon Keluarga',
              width: '200px',
              value: 'bpp_keluarga_telp_no',
              freeze: false,
              hide: false
            },
            {
              text: 'Pelapor',
              width: '300px',
              value: 'bpp_pelapor_nama',
              freeze: false,
              hide: false
            },
            {
              text: 'NIK Pelapor',
              width: '200px',
              value: 'bpp_pelapor_nik',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: 'bpp_',

          // CONFIG PARSING FORM
          form: [],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'bpp/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: false,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>